<template>
  <table class="text-center p-0 m-0 table">
    <thead>
    <tr>
      <th v-t="'factor.order_summarize.price'"></th>
      <th v-t="'factor.order_summarize.offer'"></th>
      <th v-t="'factor.order_summarize.paying_amount'"></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ formatNumber(parseInt(info.total_amount)) }}</td>
      <td>{{ formatNumber(parseInt(info.offer_amount)) }}</td>
      <td>{{ formatNumber(parseInt(info.paying_amount)) }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {dateConverter} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'

export default {
  name: "SummarizeOrder",
  props: {
    info: {}
  },
  methods:{
    formatNumber,
    dateConverter,
  }
}
</script>

<style scoped>

</style>